<template>
    <card class="mb-5">
        <template slot="body">
            <h6 class="heading-small text-muted">Company Owner Information</h6>
            <!-- {{-- for sole Proprietorship --}} -->
            <div v-if="isOwner" class="row">
                <div class="col-lg-4 col-sm-12">
                    <form-input placeholder="Last Name" label="Last Name" v-model="form.owner_lastname" ref="owner_lastname"></form-input>
                </div>
                <div class="col-lg-5 col-sm-12">
                    <form-input placeholder="First Name" label="First Name" v-model="form.owner_firstname" ref="owner_firstname"></form-input>
                </div>
                <div class="col-lg-3 col-sm-12">
                    <form-input placeholder="Middle Name" label="Middle Name" v-model="form.owner_middlename" ref="owner_middlename"></form-input>
                </div>
            </div>
            
            <!-- {{-- for Corporation --}} -->
            <div v-else class="row">
                <div class="col-lg-10 col-sm-12">
                    <form-input placeholder="Principal/s" label="Principal/s" v-model="form.principals" ref="principals"></form-input>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <button v-if="!isRequesting" class="btn btn-warning float-right" @click="next">
                        Next <i class="fas fa-angle-right ml-2"></i>
                    </button>
                    <button v-else class="btn btn-warning float-right" disabled>
                        <i class="fa fa-spinner fa-spin mr-2"></i> Please wait
                    </button>
                </div>
            </div>
        </template>
    </card>
</template>
<script>
import mixins from "@utils/mixins";
import { validateOwnerInfo } from "../helpers";

export default {
    name: "OwnerInfoSection",

    computed: {
        isOwner() {
            return this.$parent.$parent.data.is_owner;
        }
    },

    data: () => ({
        isRequesting: false,
        form: {
            owner_lastname: "",
            owner_firstname: "",
            owner_middlename: "",
            principals: "",
        },
    }),

    methods: {
        initialize() {
            console.log(this.$parent.$parent);
            this.isRequesting = false;

            if (this.$parent.$parent.data.is_owner) {
                this.form.owner_firstname = this.$parent.$parent.data.firstname;
                this.form.owner_middlename = this.$parent.$parent.data.middlename;
                this.form.owner_lastname = this.$parent.$parent.data.lastname;
            }
        },

        next() {
            this.isRequesting = true;
            validateOwnerInfo(this.businessType, this.form)
                .then(response => this.$emit("next", {...this.form}))
                .catch(error => {
                    console.log(error);
                    this.promptFormErrors(this.$refs, error)
                })
                .finally(() => this.isRequesting = false);
        },
    },

    mixins: [mixins],

    props: {
        businessType: String,
    },

    mounted() {
        this.initialize();
    }
}
</script>